export const PhoneCountryList = [
	{ code: 'GH', name: 'Ghana' },
	{ code: 'KE', name: 'Kenya' },
	{ code: 'NG', name: 'Nigeria' },
	{ code: 'GB', name: 'United Kingdom' },
];
